import { render, staticRenderFns } from "./AccountReviewModal.vue?vue&type=template&id=60764b73&"
import script from "./AccountReviewModal.vue?vue&type=script&lang=ts&"
export * from "./AccountReviewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
